export default __webpack_public_path__ + "static/ryu-c8f681a563f4dd3f88ea77fb61aa3f4e.png";